export enum EventEnum {
  ADD_LOADER_QUEUE_ITEM = 'addLoaderQueueItem',
  REMOVE_LOADER_QUEUE_ITEM = 'removeLoaderQueueItem',
}

// Custom Form Events
export enum FormEventEnum {
  FORM_SUBMITTED = 'formSubmitted',
}

export interface IFormEventEnumMap {
  [FormEventEnum.FORM_SUBMITTED]: { formDatasource: string };
}
